<template>
  <img
    v-bind="$attrs"
    :src="source.src"
    :srcset="source.srcset || null"
    :sizes="source.srcset ? sizes : null"
    @error="fallbackToOriginal"
  >
</template>

<script>
import { responsiveImageSources } from '@/utils/responsive-image'

export default {
  name: 'ResponsiveImage',
  inheritAttrs: false,
  props: {
    original: { type: String, default: '' },
    variants: { type: Object, default: () => ({}) },
    preferred: { type: Array, default: () => [] },
    sizes: { type: String, default: '100vw' }
  },
  data () {
    return { failed: false }
  },
  computed: {
    source () {
      if (this.failed) return { src: this.original, srcset: '' }
      return responsiveImageSources(this.original, this.variants, this.preferred)
    }
  },
  watch: {
    original () { this.failed = false },
    variants: {
      deep: true,
      handler () { this.failed = false }
    }
  },
  methods: {
    fallbackToOriginal () {
      if (this.source.src !== this.original) this.failed = true
    }
  }
}
</script>
